import {slideDown, slideUp} from "../../helpers/animation";

export const setError = (error, errorEl, inputEl, errorClass = `${inputEl.classList[0]}--error`) => {
  inputEl.classList.add(errorClass);
  errorEl.innerText = error;
  slideDown(errorEl);
}

export const removeError = (errorEl, inputEl, errorClass= `${inputEl.classList[0]}--error`) => {
  inputEl.classList.remove(errorClass);
  errorEl.innerText = '';
  slideUp(errorEl);
}
